import { render, staticRenderFns } from "./LernzielvereinbarungBewertungModal.vue?vue&type=template&id=457b4a1f&"
import script from "./LernzielvereinbarungBewertungModal.vue?vue&type=script&lang=js&"
export * from "./LernzielvereinbarungBewertungModal.vue?vue&type=script&lang=js&"
import style0 from "./LernzielvereinbarungBewertungModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports